// extracted by mini-css-extract-plugin
export default {"toggle_of_sub_navlinks":"Roles_toggle_of_sub_navlinks__XHkiq","toggle_of_sub_navlinks1":"Roles_toggle_of_sub_navlinks1__3XfN2","sub_navlinks":"Roles_sub_navlinks__km1yz"};